import { FormattedMessage } from 'react-intl';

import { emptyObject } from 'ui-components/default-props/empty';
import { noop } from 'ui-components/default-props/noop';

import { CostReviewLabelProviderInsuranceLineItem } from './cost-review-label-provider-insurance-line-item';
import { messages } from '../messages';

/**
 * @param {object} props
 * @param {Array<LabelProviderCostReviewLineItem>} [props.insuranceLineItems]
 * @param {number} [props.insuranceSubtotal]
 * @param {CostReviewInsuranceRecommendation} [props.insuranceRecommendation]
 * @param {(recommendationKey: string) => void} [props.onToggleRecommendation]
 * @param {boolean} [props.isToggleRecommendationDisabled]
 * @param {boolean} [props.isRecommendationSelected]
 * @returns {React.JSX.Element|Array<React.JSX.Element>}
 */
export const CostReviewLabelProviderInsurance = ({
  insuranceLineItems,
  insuranceSubtotal,
  insuranceRecommendation = emptyObject,
  onToggleRecommendation = noop,
  isToggleRecommendationDisabled = false,
  isRecommendationSelected = false,
}) => {
  if (insuranceSubtotal && !insuranceLineItems?.length) {
    return (
      <CostReviewLabelProviderInsuranceLineItem
        insuranceRecommendation={insuranceRecommendation}
        insuranceServiceCostAmount={insuranceSubtotal}
        insuranceServiceName={<FormattedMessage {...messages.insurance} />}
        isRecommendationSelected={isRecommendationSelected}
        isToggleRecommendationDisabled={isToggleRecommendationDisabled}
        onToggleRecommendation={onToggleRecommendation}
      />
    );
  }

  return insuranceLineItems.map((insuranceLineItem) => {
    return (
      <CostReviewLabelProviderInsuranceLineItem
        key={insuranceLineItem.id}
        insuranceRecommendation={insuranceRecommendation}
        insuranceServiceCostAmount={insuranceLineItem.amount?.value}
        insuranceServiceCostCurrencyCode={insuranceLineItem.amount?.code}
        insuranceServiceName={insuranceLineItem.description}
        isRecommendationSelected={isRecommendationSelected}
        isToggleRecommendationDisabled={isToggleRecommendationDisabled}
        onToggleRecommendation={onToggleRecommendation}
      />
    );
  });
};
